import { notificationCreate } from '@/services/token/notifications.service'

export default {
	namespaced: true,
	state: {
		notificationsSaveStatus: 'init',
	},
	getters: {
		getNotificationsSaveStatusToken(state) {
			return state.notificationsSaveStatus
		},
	},
	mutations: {
		NOTIFICATION_SAVE_STATUS(state, value) {
			state.notificationsSaveStatus = value
		},
	},
	actions: {
		async saveNewNotificationToken({ commit }, params) {
			commit('NOTIFICATION_SAVE_STATUS', 'pending')
			try {
				const { data } = await notificationCreate(params)
				commit('NOTIFICATION_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('NOTIFICATION_SAVE_STATUS', 'init')
				throw error
			}
		},
	},
}
